import { Paper, Skeleton, Stack, Typography } from '@mui/material';
import React from 'react';

const SKELETON_HEIGHT = 260;

/** Shared by every chart card so the charts and their empty states line up in the dashboard grid. */
export const CHART_HEIGHT = 220;

interface Props {
  title: string;
  subtitle: string;
  isLoading: boolean;
  children: React.ReactNode;
}

/** Shared shell for the dashboard chart cards: heading, subheading and the loading skeleton. */
const ChartCard: React.FC<Props> = ({ title, subtitle, isLoading, children }) => (
  <Paper elevation={3} sx={{ height: '100%' }}>
    <Stack padding={2} gap={2} width="100%">
      <Stack>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Stack>

      {isLoading ? <Skeleton variant="rectangular" height={SKELETON_HEIGHT} /> : children}
    </Stack>
  </Paper>
);

export default ChartCard;
